/* Publish by EComposer at 2026-10-22 12:26:30*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-yuhvqbi533"]=  window.__ectimmers["ecom-yuhvqbi533"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),s=t.querySelector(".text-content.ecom-html");!s||(e&&e.addEventListener("click",()=>{s.classList.remove("ecom-text--is-mark"),s.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{s.classList.add("ecom-text--is-mark"),s.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-yuhvqbi533').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yuhvqbi533', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dsxawkge1tn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dsxawkge1tn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-khu2ladb6bm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-khu2ladb6bm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ufhtplm3mug').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ufhtplm3mug', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-813zvhxlgg7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-813zvhxlgg7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xet3r653uy').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xet3r653uy', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bvsxyi7sxvb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bvsxyi7sxvb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-plgfbe2oou7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-plgfbe2oou7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-t8iztzx0ati').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-t8iztzx0ati', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-95gznxbn1p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-95gznxbn1p', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lmn5zi8qdtr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lmn5zi8qdtr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-oq8yk01e8zk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-oq8yk01e8zk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-drgfxrdc71d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-drgfxrdc71d', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wrtzonu5s5h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wrtzonu5s5h', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rsnuvrd12o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rsnuvrd12o', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gggk59xd99i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gggk59xd99i', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-j5o9b6xfrpe').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-j5o9b6xfrpe', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5fwebfsb7qv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5fwebfsb7qv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-74103ulhnrq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-74103ulhnrq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6d8c2k9a948').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6d8c2k9a948', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-imt0fwgvgjm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-imt0fwgvgjm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hxlgvee4hej').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hxlgvee4hej', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wz9ps56zi8n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wz9ps56zi8n', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mfu6xap8uj8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mfu6xap8uj8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gkgksva9bu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gkgksva9bu', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4r85xdgy60k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4r85xdgy60k', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-x1p8igen69b"]=  window.__ectimmers["ecom-x1p8igen69b"] || {};
const t=this.$el;if(!t||!this.isLive)return;const e=t.querySelector(".element__featured--wrapper-list");if(e){let i={top:0,left:0,x:0,y:0};const s=function(r){const a=r.clientX-i.x;e.scrollLeft=i.left-a},o=function(){e.removeEventListener("mousemove",s),e.removeEventListener("mouseup",o),e.style.cursor="default",e.style.removeProperty("user-select")},n=function(r){e.style.cursor="grabbing",e.style.userSelect="none",i={left:e.scrollLeft,top:e.scrollTop,x:r.clientX,y:r.clientY},e.addEventListener("mousemove",s),e.addEventListener("mouseup",o)};e.addEventListener("mousedown",n),e.addEventListener("mouseleave",o)}

                    });
                    
                        document.querySelectorAll('.ecom-x1p8igen69b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-x1p8igen69b', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-hi27odvt4s9"]=  window.__ectimmers["ecom-hi27odvt4s9"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const s=t.querySelector(".ecom__element--button");if(!s)return;let o=parseInt(i.settings.animation_loop_time)*1e3||6e3,n=1e3;window.__ectimmers["ecom-hi27odvt4s9"]["mj2hdvnsm"] = setInterval(function(){s.classList.add("animated"),setTimeout(function(){s.classList.remove("animated")},n)},o)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let s=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},s);try{Shopify.analytics.publish("ec_custom_events",o)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const n=e.getAttribute("href"),r=e.getAttribute("target");n&&n!=="#"&&n!=="javascript:void(0)"&&(r==="_blank"?window.open(n,"_blank"):setTimeout(function(){window.location.href=n},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-hi27odvt4s9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hi27odvt4s9', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pzb9ua42rbp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pzb9ua42rbp', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vl81ku9dfli').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vl81ku9dfli', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dm43m3dohk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dm43m3dohk', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-u43iljhw2ge').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u43iljhw2ge', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-d59axp9wnim').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d59axp9wnim', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gd70st5xwdf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gd70st5xwdf', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-sz2c1t47m4"]=  window.__ectimmers["ecom-sz2c1t47m4"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-sz2c1t47m4"]["0x19z8u4d"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let s=this.$el;if(!s)return;function o(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let r=s.querySelector(".ecom-element.ecom-base-image"),a=s.closest(".core__row--columns");r&&(o(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-sz2c1t47m4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sz2c1t47m4', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-x9mukp8iqz').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-x9mukp8iqz', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a4qd3t21ktr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a4qd3t21ktr', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-t8p4vg7f6nj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-t8p4vg7f6nj', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fy5uyqdlcf4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fy5uyqdlcf4', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lux74o5dek').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lux74o5dek', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-chn2ycnqkxr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-chn2ycnqkxr', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}